<app-topbar></app-topbar>
<ng-container>
    <div class="main-content">
        <h3 class="newpassword-header">Reset password</h3>

        <form class="form-newpassword" [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="password">Temporary password</label>
                <input
                    type="password"
                    class="form-control"
                    formControlName="passwordTemporary"
                    id="passwordTemporary"
                    placeholder="Temporary password"
                    [ngClass]="{'is-invalid': (passwordTemporary.touched || passwordTemporary.dirty) && !passwordTemporary.valid, 'is-valid': passwordTemporary.valid}"
                />
                <div id="incorrect" class="invalid-feedback" *ngIf="passwordTemporary.errors?.['incorrect']">
                    Temporary password is incorrectd
                  </div>
            </div>
            <div class="form-group">
                <label for="password">New password</label>
                <input
                    type="password"
                    class="form-control"
                    id="passwordNew"
                    formControlName="passwordNew"
                    placeholder="New password"
                    aria-describedby="passwordHint, passwordMatch"
                    [ngClass]="{'is-invalid': (passwordNew.touched || passwordNew.dirty) && (!passwordNew.valid || newPasswordForm.errors?.['passwordMatch']), 'is-valid': passwordNew.valid}"
                />
                <div id="passwordMatch" class="invalid-feedback" *ngIf="newPasswordForm.errors?.['passwordMatch']">
                    New password may not match temporary password
                  </div>
                <small id="passwordHint" class="form-text text-muted">Password must be at least 8 characters long. It is recommended that the password contain uppercase, lowercase, numbers and special characters</small>
            </div>
            <div class="form-group">
                <label for="password">Confirm password</label>
                <input
                    type="password"
                    class="form-control"
                    formControlName="passwordConfirm"
                    id="passwordConfirm"
                    placeholder="Confirm password"
                    [ngClass]="{'is-invalid': (passwordConfirm.touched || passwordConfirm.dirty) && (!passwordConfirm.valid || newPasswordForm.errors?.['passwordMismatch']), 'is-valid': passwordConfirm.valid}"
                />
            </div>
            <button type="submit" class="btn btn-primary" [disabled]="!newPasswordForm.valid">Save password</button>
        </form>
    </div>
</ng-container>
